import Swiper, { Navigation, Pagination } from 'swiper';
document.addEventListener('DOMContentLoaded', function () {
    const productSwipers = document.querySelectorAll('.product-swiper');
    // Get Number of Slides per view from toggle
    productSwipers.forEach(el => {
        const numberOfSlides = parseInt(el.getAttribute('number-of-slides'));
        new Swiper(el, {
            modules: [Navigation, Pagination],
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            allowTouchMove: true,
            // Prevent accidental trackpad sliding
            threshold: 4,
            autoplay: {
                delay: 5000,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: numberOfSlides,
                },
            },
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
                hideOnClick: false,
            },
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
        });
    });
});
